import { IMetaFormat } from '../roundFormats/store';

export enum ScoreType {
  'GROSS' = 1,
  'NET' = 2
}

export interface IAdminEventFormatsStore {
  [eventId: number]: IMetaFormat[];
}

export const adminEventFormatsStore: IAdminEventFormatsStore = {};
